import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../view/Commissionbalance.vue'

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/DetailsOfBalance',
    name: 'DetailsOfBalance',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "DetailsOfBalance" */ '../view/DetailsOfBalance.vue')
  },
  {
    path: '/Reflect',
    name: 'Reflect',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Reflect" */ '../view/Reflect.vue')
  },
  {
    path: '/reflectSuccess',
    name: 'reflectSuccess',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "reflectSuccess" */ '../view/reflectSuccess.vue')
  },
  {
    path: '/share',
    name: 'share',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "share" */ '../view/share.vue')
  },
  {
    path: '/myTeam',
    name: 'myTeam',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "myTeam" */ '../view/myTeam.vue')
  },
  {
    path: '/healthConsultant',
    name: 'healthConsultant',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "myTeam" */ '../view/healthConsultant.vue')
  },
  {
    path: '/shareDetails',
    name: 'shareDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "myTeam" */ '../view/shareDetails.vue')
  },
  {
    path: '/healthyDetails',
    name: 'healthyDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "myTeam" */ '../view/healthyDetails.vue')
  },
  {
    path: '/achievementDetails',
    name: 'achievementDetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "myTeam" */ '../view/achievementDetails.vue')
  },
  {
    path: '/recharge',
    name: 'recharge',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "myTeam" */ '../view/recharge.vue')
  },
  {
      path: '/bindingZfb',
      name: 'bindingZfb',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
          import ( /* webpackChunkName: "myTeam" */ '../view/bindingZfb.vue')
  },
  {
      path: '/Transfer',
      name: 'transfer',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
          import ( /* webpackChunkName: "myTeam" */ '../view/transfer.vue')
  },
]

const router = new VueRouter({
  routes,

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js